import { render, staticRenderFns } from "./DictSelect.vue?vue&type=template&id=481f49c5&scoped=true&"
import script from "./DictSelect.vue?vue&type=script&lang=js&"
export * from "./DictSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481f49c5",
  null
  
)

export default component.exports